import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import Home from "./pages/home";
import MenuIcon from "@mui/icons-material/Menu";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { COLORS } from "./utils/colors";
import Property from "./pages/property";
import { APIProvider } from "@vis.gl/react-google-maps";

function App() {
  return (
    <APIProvider
      apiKey={"AIzaSyDW3zs0u0TgejjpkAGxliJFOhd1MrvsNLg"}
      onLoad={() => console.log("Maps API has loaded.")}
    >
      <Router>
        <Box sx={{ padding: 0 }}>
          <AppBar
            position="static"
            style={{ backgroundColor: COLORS.SURFACE_2 }}
          >
            <Toolbar>
              {/* <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              >
              <MenuIcon />
              </IconButton> */}
              <Button color="inherit" href="/" style={{ padding: 0 }}>
                <img
                  src="/logo.png"
                  alt="Logo"
                  style={{ width: "auto", height: "60px", marginRight: 10 }}
                />
                {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Property Calculator
                </Typography> */}
              </Button>
              {/* <Button color="inherit">Login</Button> */}
            </Toolbar>
          </AppBar>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Routes>
              <Route path="/property/:propertyId" element={<Property />} />
              <Route path="/" element={<Home />} />
            </Routes>
          </LocalizationProvider>
        </Box>
      </Router>
    </APIProvider>
  );
}

export default App;
